import create from 'zustand';

export type OnboardingSheetSource =
  | 'welcome'
  | 'ring'
  | 'dropdown'
  | 'settings'
  | null;

interface SheetState {
  isOpen: boolean;
  source: OnboardingSheetSource;
  openSheet: (source?: OnboardingSheetSource) => void;
  closeSheet: () => void;
}

export const useOnboardingSheetStore = create<SheetState>(set => ({
  isOpen: false,
  source: null,
  openSheet: (source = null) => set({isOpen: true, source}),
  closeSheet: () => set({isOpen: false, source: null}),
}));

export default useOnboardingSheetStore;
